import type { ManagedPerson } from "#shared/managePeopleContract.ts";
import { Badge } from "@/components/ui/badge.tsx";
import { SectionTitle } from "@packages/core-client/components/SectionTitle.tsx";
import { useI18nextInstance } from "@squide/i18next";
import { useTranslation } from "react-i18next";
import { i18NextInstanceKey } from "../../../i18n/i18next.ts";
import { PERSON_STATUS_BADGE_INTENT } from "../personStatusBadge.ts";
import type { PersonHeaderAction } from "./personDetailHeaderActions.ts";
import { PersonDetailHeaderActions } from "./PersonDetailHeaderActions.tsx";

export interface PersonDetailHeaderProps {
    person: ManagedPerson;
    isSelf: boolean;
    pendingAction: PersonHeaderAction | undefined;
    onAction: (action: PersonHeaderAction) => void;
}

export function PersonDetailHeader({ person, isSelf, pendingAction, onAction }: PersonDetailHeaderProps) {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t: tShared } = useTranslation("managePeople", { i18n: i18nextInstance });

    return (
        <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 sm:flex-nowrap">
            <div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1 sm:flex-nowrap">
                <SectionTitle size="page" className="min-w-0 truncate">
                    {person.displayName}
                </SectionTitle>
                <Badge intent={PERSON_STATUS_BADGE_INTENT[person.status]} isCircle={false} className="sm:shrink-0 [[data-loading]_&]:hidden">
                    {tShared(`statuses.${person.status}`)}
                </Badge>
            </div>
            <div className="sm:shrink-0 [[data-loading]_&]:hidden">
                <PersonDetailHeaderActions status={person.status} isSelf={isSelf} pendingAction={pendingAction} onAction={onAction} />
            </div>
        </div>
    );
}
